import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as A from '../store/lineageActions';
import {APP_TYPES} from '../util/theme';

/**
 * Node palette (class + connect() per convention). Drag a type onto the canvas
 * or click to drop one at the origin. Drag payload is read by LineageEditor.onDrop.
 */
class Palette extends Component {
  onDragStart = (e, appType) => {
    e.dataTransfer.setData('application/lineage-appType', appType);
    e.dataTransfer.effectAllowed = 'move';
  };

  render() {
    return (
      <div className="ln-palette" data-testid="lineage-palette">
        <div className="ln-palette-title">Add node</div>
        {APP_TYPES.map((t) => (
          <div
            key={t}
            className={`ln-palette-item ln-palette-${t}`}
            draggable
            onDragStart={(e) => this.onDragStart(e, t)}
            onClick={() => this.props.createNode(t, {x: 120, y: 120})}
            data-testid={`palette-${t}`}
          >
            {t}
          </div>
        ))}
      </div>
    );
  }
}

export default connect(null, {createNode: A.createNode})(Palette);
